import { Axios, AxiosResponse } from 'axios'

export interface FuzokuMeisaiService {
  exportJunsoku (startDate: string, endDate: string): Promise<AxiosResponse>;

  exportKaikeiKijun (startDate: string, endDate: string): Promise<AxiosResponse>;
}

export class FuzokuMeisaiServiceImpl implements FuzokuMeisaiService {
  constructor (http: Axios) {
    this.http = http
  }

  private readonly http: Axios

  async exportJunsoku (startDate: string, endDate: string): Promise<AxiosResponse> {
    return await this.http.post(
      'fuzoku/junsoku/export',
      {
        startDate: startDate,
        endDate: endDate
      },
      { responseType: 'blob' }
    )
  }

  async exportKaikeiKijun (startDate: string, endDate: string): Promise<AxiosResponse> {
    return await this.http.post(
      'fuzoku/kaikei-kijun/export',
      {
        startDate: startDate,
        endDate: endDate
      },
      { responseType: 'blob' }
    )
  }
}
